function loadCalendarSheadule(availableDays = [11, 12, 13, 14, 17, 22, 23]) {
  const calendarDays = document.getElementById("calendarDays");
  const monthYear = document.getElementById("monthYear");
  const prevMonthBtn = document.getElementById("prevMonth");
  const nextMonthBtn = document.getElementById("nextMonth");

  if (!calendarDays || !monthYear || !prevMonthBtn || !nextMonthBtn) return;

  let currentDate = new Date();
  let selectedDate = null;

  function renderCalendar(date) {
    calendarDays.innerHTML = "";
    const year = date.getFullYear();
    const month = date.getMonth();

    const monthNames = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ];

    monthYear.textContent = `${monthNames[month]} de ${year}`;

    const firstDay = new Date(year, month, 1).getDay();
    const lastDate = new Date(year, month + 1, 0).getDate();

    for (let i = 0; i < firstDay; i++) {
      const emptyDiv = document.createElement("div");
      calendarDays.appendChild(emptyDiv);
    }

    for (let day = 1; day <= lastDate; day++) {
      const dayDiv = document.createElement("div");
      dayDiv.classList.add("day");
      dayDiv.textContent = day;

      const today = new Date();
      const isToday =
        day === today.getDate() &&
        month === today.getMonth() &&
        year === today.getFullYear();

      const isAvailable = availableDays.includes(day);
      if (isAvailable) {
        dayDiv.classList.add("available");
      }

      if (isToday && isAvailable) {
        selectedDate = dayDiv;
        dayDiv.classList.add("selected");
      }

      dayDiv.addEventListener("click", function () {
        if (!dayDiv.classList.contains("available")) return;

        if (selectedDate) {
          selectedDate.classList.remove("selected");
        }
        selectedDate = dayDiv;
        dayDiv.classList.add("selected");
      });

      calendarDays.appendChild(dayDiv);
    }
  }

  prevMonthBtn.addEventListener("click", function () {
    currentDate.setMonth(currentDate.getMonth() - 1);
    renderCalendar(currentDate);
  });

  nextMonthBtn.addEventListener("click", function () {
    currentDate.setMonth(currentDate.getMonth() + 1);
    renderCalendar(currentDate);
  });

  renderCalendar(currentDate);
}

// FUNÇÃO DESATIVADA - Usando plugin Order Delivery Date agora
/*
function changeStepModalScheaduleDelivery() {
  const modalSheadule = document.getElementById("modalScheduleDelivery");

  if (!modalSheadule) return;

  const buttonSheaduleAgain = modalSheadule.querySelector(
    ".modal-footer ,sheadule-again"
  );
  const buttonSheadule = modalSheadule.querySelector(
    ".content-unfilled .sheadule"
  );

  buttonSheadule.addEventListener("click", (e) => {
    modalSheadule.classList.add("filled");
  });

  buttonSheaduleAgain.addEventListener("click", (e) => {
    modalSheadule.classList.remove("filled");
  });
}
*/

function setupSelectableList(
  containerSelector,
  itemSelector,
  selectedClass = "selected"
) {
  const container = document.querySelector(containerSelector);
  if (!container) return;

  container.addEventListener("click", (event) => {
    const clickedItem = event.target.closest(itemSelector);
    if (!clickedItem) return;

    container
      .querySelectorAll(`${itemSelector}.${selectedClass}`)
      .forEach((item) => {
        item.classList.remove(selectedClass);
      });

    // if (containerSelector === ".list-payment-options") {
    //   const formContainer = document.querySelector(
    //     ".wrapper-payment .form-credit-card"
    //   );
    //   const paymentMethot = clickedItem.getAttribute("data-js-payment");

    //   if (paymentMethot === "card") {
    //     formContainer.classList.add("show-form");
    //   } else {
    //     formContainer.classList.remove("show-form");
    //   }
    // }

    clickedItem.classList.add(selectedClass);
  });
}

function setFocusUserEditInfos() {
  const buttonsEdit = document.querySelectorAll(".personal-infos .edit-input");

  if (!buttonsEdit.length) return;

  buttonsEdit.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      const wrapper = button.closest(".wrapper-input-with-button");
      const input = wrapper.querySelector("input");

      input.disabled = false;
      input.focus();

      const val = input.value;
      input.value = "";
      input.value = val;
    });
  });

  document.addEventListener("click", (e) => {
    e.preventDefault();
    document.querySelectorAll(".wrapper-input-with-button").forEach((w) => {
      const i = w.querySelector("input");
      if (!w.contains(e.target)) {
        i.disabled = true;
      }
    });
  });
}

function checkoutFunctions() {
  setupSelectableList(
    ".list-address-wrapper .list-address-options",
    ".single-address-option"
  );
  setupSelectableList(".list-shipping-options", ".single-shipping-option");
  setupSelectableList(".wrapper-buttons-horario", ".single-button-horario");
  // setupSelectableList(".list-payment-options", ".single-payment-option");
  // loadCalendarSheadule(); // DESATIVADO - Usando plugin Order Delivery Date
  // changeStepModalScheaduleDelivery(); // DESATIVADO - Usando plugin Order Delivery Date
  setFocusUserEditInfos();
}

export { checkoutFunctions };
